import { isDevMode } from '@angular/core';
import { getEnvironment } from '@pct-ng/environment';
import type { MecapEnvironment } from '../environment/type';

const { PT_VERSION } = getEnvironment();

export const defaultMecapEnv = {
  app: 'mecap',
  applicationName: 'DEV',
  version: PT_VERSION,
  isAngularDevMode: isDevMode(),
  apiUrl: 'https://meapp.plaveoodev.pctrade.hu/api',
  googleMapsApiKey: 'AIzaSyB_uEiAO6rD10wKbkDytkl2mscJG5CMG-U',
  apiUrlPattern: /^https:\/\/meapp\.plaveoodev\.pctrade\.hu\/api(\/.*)?$/i,
  keycloakConfig: {
    realm: 'meapp',
    url: 'https://keycloak.milo.plaveoo.hu/',
    clientId: 'ui://a3177cc0-3fe6-44a6-b60a-f4381ee74177',
    initOptions: {
      onLoad: 'check-sso',
      redirectUri: window.location.origin,
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    },
  },
  logo: {
    primary: 'logo/Logo_Blue_Monochrome.svg',
    secondary: 'logo/Logo_White_Monochrome.svg',
  },
} as const satisfies MecapEnvironment;
